bam-form {
  display: block;
}

.bam-form--modal {
  .bal-modal__content {
    margin-top: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
